// deps
import { createContext } from "react";
import type { GetConfigValueResponsePayload } from "@swiggy-private/native-bridge";
import { ISwiggyHeaders } from "./interfaces";

export interface ISwiggyHeadersContext {
    swiggyHeaders: ISwiggyHeaders;
    dynamicFlags: GetConfigValueResponsePayload;
    setSwiggyHeaders: (headers: ISwiggyHeaders) => void;
    setDynamicFlags: (flags: GetConfigValueResponsePayload) => void;
}

const SwiggyHeadersContext = createContext<ISwiggyHeadersContext>({
    swiggyHeaders: {} as ISwiggyHeaders,
    dynamicFlags: {} as GetConfigValueResponsePayload,
    setSwiggyHeaders: (_headers: ISwiggyHeaders) => {
        // no-op
    },
    setDynamicFlags: (_flags: GetConfigValueResponsePayload) => {
        // no-op
    },
});

export default SwiggyHeadersContext;
